"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var S3_INIT = exports.S3_INIT = "S3_INIT";
var S3_FILE_UPLOADED = exports.S3_FILE_UPLOADED = "S3_FILE_UPLOADED";
//# sourceMappingURL=s3Constants.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/s3/s3Constants.js
// module id = 253
// module chunks = 0